import {GUEST_APP_EVENTS_NAME} from '../../utils/constants';

const getIdentificaiontEventName = (stateName: string) => {
  switch (stateName) {
    case 'frontSideDocumentPhoto':
      return GUEST_APP_EVENTS_NAME.IDVerificationDocument;
    case 'selfiePhoto':
      return GUEST_APP_EVENTS_NAME.IDVerificationSelfie;
    default:
      return GUEST_APP_EVENTS_NAME.IDVerificationDocument;
  }
};

export {getIdentificaiontEventName};
